import { render, staticRenderFns } from "./Email-notifications-list.vue?vue&type=template&id=64942a0e"
import script from "./Email-notifications-list.vue?vue&type=script&lang=js"
export * from "./Email-notifications-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports